export default __webpack_public_path__ + "static/media/wallet.769847ea.png";